// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from 'element-ui'

import configs from './configs'
import components from './components';
import * as echarts from 'echarts';

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);

Vue.use(components);// 全局注册组件

Vue.prototype.$configs = configs; //全局注册configs



// import Vconsole from 'vconsole'
//
// let vConsole = new Vconsole()
//
// Vue.use(vConsole);

/* eslint-disable no-new */

// router.beforeEach((to,from,next)=>{
//   console.log(1111)
//   if(to.path == '/login' || to.path == '/'){
//     next();
//   }else{
//     console.log(2222)
//     let saveUser = localStorage.getItem('userInfo');
//     let userInfo = saveUser?JSON.parse(saveUser):"";
//     if(userInfo && userInfo.token){
//       next()
//     }else{
//       next("/login");
//     }
//   }
//   next();
// })


new Vue({
  el: '#app',
  router,
  store,
  performance: true,
  render: h=> h(App),
  components: { App },
  // template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js